import React from 'react';
import { Alert } from '@fx-ui/fine-design';
import { Hyperlink } from '@fx-ui/jdy-design-biz';
import Intl from '@fx-ui/intl';
import { helpSourceIntl } from '~/constants';
import { getIntegratedPlatformName } from './corp';

/** 集成同步受管时，手动开启子产品的提示。 */
export const openIntegratedSuiteEnableAlert = (
    currentCorpType?: Parameters<typeof getIntegratedPlatformName>[0]
) => {
    Alert.openAlert({
        type: 'warning',
        title: Intl.get('fxp.base.not_installed_im_app.ttl'),
        message: Intl.get('fxp.base.install_im_app_to_use_product.tip', {
            platformName: getIntegratedPlatformName(currentCorpType)
        }),
        footerLeft: (
            <Hyperlink
                underline
                compact
                href={helpSourceIntl.get('doc_product_center')}
                target="jdy_doc"
            >
                {Intl.get('fxp.learn_more.btn')}
            </Hyperlink>
        ),
        text4Cancel: null,
        text4Ok: Intl.get('fxp.got_it.btn')
    });
};
